import { render, staticRenderFns } from "./editKindergruppenLeitung.vue?vue&type=template&id=73d06e22&scoped=true&"
import script from "./editKindergruppenLeitung.vue?vue&type=script&lang=js&"
export * from "./editKindergruppenLeitung.vue?vue&type=script&lang=js&"
import style0 from "./editKindergruppenLeitung.vue?vue&type=style&index=0&id=73d06e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d06e22",
  null
  
)

export default component.exports